import React from 'react';
const ConfigContext = /*#__PURE__*/React.createContext({
  msrp: 0,
  dealerId: null,
  // mmdId
  dealerZip: '',
  digitalRetailingType: 'default',
  // supports ['default', 'psx', 'accelerate']
  disableCreditTierSelection: false,
  // disable credit tier dropdown, Currently, BOA only
  disableIncentives: false,
  disableTrade: false,
  disclaimerKey: 'default',
  // supports ['default', 'PSX', 'CoxAuto']
  ecommerce: '',
  // supports tenants 'CoxAuto', 'Accelerate', 'BOA', and 'PSX'
  enableCreditVerification: false,
  // show credit verification CTA
  enableExternalPaymentFetch: false,
  enableNegotiation: false,
  enableOfferUpgrades: true,
  enablePayoffQuote: false,
  enablePriceDetailsInOfferBreakdown: false,
  enableTaxesAndFees: false,
  enableWalletByDefault: false,
  // PSX and CoxAuto tenants only
  esntialDeepLink: {},
  enableLenderDisclaimerCTA: false,
  hideCTAs: false,
  // true for PSX tenant only
  hideSendOfferCTA: false,
  includeTaxesAndFees: false,
  interestRates: {},
  isDueAtSigningAmountDeduct: false,
  // applies to lease only
  isSingleColumn: false,
  isUDSStandAlone: false,
  oemLabels: {},
  ownerInfo: {},
  // BOA only - owner info from DR settings
  partnerId: '',
  // AMK or MMD
  paymentCalculationFetcher: {},
  paymentCalculationUrl: '',
  paymentIncentivesFetcher: {},
  selectedCriteria: {},
  shopperZip: '',
  showLenderDisclaimer: true,
  showLenderName: true,
  showLendingOptions: true,
  showMsrp: true,
  showNationalAvg: true,
  // Displays national average
  showRatesTable: false,
  updateDealXgFetcher: {},
  walletZip: '',
  shortCustomDisclaimer: '',
  // accelerate tenant only
  showWalletSyncBanner: false,
  isEcommHyundai: false // ecomm Hyundai Buy Online Experience
});
export { ConfigContext as default };
